import { InformationCircle, PhoneIcon } from 'assets/icons';
import useHomeText from 'hooks/useHomeText';
import { useState } from 'react';

const STEPS = [
  ['tasks.groupLate', 'order.late'],
  ['tasks.groupFixed', 'order.fixed'],
  ['tasks.groupNone', 'order.none'],
  ['tasks.groupDone', 'order.done'],
];

/**
 * « Pourquoi cet ordre ? »: the groups of the list, in their order and under
 * their names. Opens on hover or focus; a click keeps it open, for the
 * keyboard and touch screens.
 */
const OrderHelp = ({ lateShown }) => {
  const { text } = useHomeText();
  const [open, setOpen] = useState(false);
  return (
    <span
      className="relative flex"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        className="flex items-center gap-1 text-xs font-medium text-gray-900 underline-offset-2 hover:underline"
      >
        <InformationCircle wh={15} color="currentColor" />
        {text('order.link')}
      </button>
      {open && (
        <span className="absolute left-0 top-full z-20 w-96 pt-2 motion-safe:animate-contentIn">
          <span className="block rounded-xl border border-gray-100 bg-white p-4 shadow-lg">
            <span className="block text-sm font-semibold text-gray-900">{text('order.title')}</span>
            <span className="mt-3 flex flex-col gap-3">
              {STEPS.map(([title, detail], index) => (
                <span key={title} className="flex items-start gap-3">
                  <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-700">
                    {index + 1}
                  </span>
                  <span className="flex flex-col">
                    <span className="text-sm font-medium leading-5 text-gray-900">{text(title)}</span>
                    <span className="text-sm leading-5 text-gray-600">
                      {text(detail, { count: lateShown })}
                    </span>
                  </span>
                </span>
              ))}
            </span>
            <span className="mt-4 flex items-start gap-3 border-t border-gray-100 pt-3 text-sm leading-5 text-gray-600">
              <span className="mt-0.5 shrink-0 text-gray-400">
                <PhoneIcon wh={16} color="currentColor" />
              </span>
              {text('order.calls')}
            </span>
          </span>
        </span>
      )}
    </span>
  );
};

export default OrderHelp;
